/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const wbase: CommunityData = {
  code: "wbase",
  inviteCode: "wbase",
  waitlist: true,
  name: "Wbase",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/wbase`,
  socials: {},
  defaultCurrency: "SEK",
  styles: {
    comingSoon: {
      bgColor: "#E8E8E8",
      hero: {
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: "/assets/customizations/base/logo.png",
        mobile: "/assets/customizations/base/logo.png",
        style: "w-[130px]",
      },
      werzLogoColor: "#000000",
      title: "font-['Inter'] font-medium text-[28px] leading-[120%] text-[#000000]",
      text: "font-['Inter'] text-[16px] leading-[120%] text-[#6B6B6B]",
      button:
        "font-['Inter'] text-[14px] leading-[120%] p-4 rounded-[8px] bg-[#000000] text-[#FFFFFF] cursor-pointer w-fit",
      input: {
        base: "font-['Inter'] text-[14px] leading-[120%] w-[256px] rounded-[8px] px-4 h-[48px] bg-white",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['Inter'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['Inter'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton: "font-['Inter'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#F0F0F0] px-[40px] py-[48px]",
        title: "font-['Inter'] text-[24px] leading-[120%] text-[#000000] text-center",
        text: "font-['Inter'] text-[14px] leading-[120%] text-[#6B6B6B] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-black bg-white font-['Inter'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      counterColor: "#000000",
      logo: {
        src: "/assets/customizations/base/logo.png",
        styles: "w-[130px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "",
      bgColor: "#B4B4B4",
      asideBg: "#FFFFFF",
      asideStyles: "",
      contentBg: "#FFFFFF",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['Arial']",
      primaryButton:
        "flex mt-2 !text-[#FFFFFF] uppercase justify-center items-center !text-[14px] !h-[48px] bg-[#000000] !px-[16px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      iconsColor: "#000000",
      separator: "border-t-[#000000] border-t",
      item: "text-[18px] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-2 !pt-6",
      itemSelected: "",
    },
    communityLanding: {
      titles: "text-[24px] leading-[24px] font-bold",
      announcements: {
        lg: {
          subtitle:
            "!text-[11px] px-[6px] !pt-[6px] !bg-[#000000] !text-[#FFFFF] w-fit h-[19px] flex items-center",
          title:
            "leading-[27px] !text-[#000000] !text-[24px] -mb-2 mt-[-4px] px-[6px] w-fit flex items-center",
        },
        sm: {
          subtitle:
            "!text-[11px] px-[6px] !pt-[6px] !bg-[#000000] !text-[#FFFFF] w-fit h-[19px] flex items-center",
          title:
            "!text-[24px] !text-[#000000] leading-[27px] mt-[-4px] px-[6px] w-fit flex items-center",
        },
      },
      event: {
        title: "text-[14px] one-line-truncate font-bold",
        subtitle: "text-[14px] leading-[16px]",
      },
      shop: {
        title: "text-[20px] leading-[20px] font-bold",
        text: "text-[13px] leading-[24px]",
        customShopImage: "",
      },
      emptyOrLoadingState: "text-[16px] font-bold",
    },
    linktree: {
      communityInfo: {
        button: "",
        description: "font-mono text-[11px] text-center mb-4",
        location: "text-[14px] uppercase text-[#000000] font-mono mb-1",
        logo: "",
        name: "text-[28px] font-sans mt-[10px] mb-1",
        socialMediaIconColor: "#000000",
      },
      bgDesktop: "",
      bgMobile: "",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#FEFEF9] p-[64px]",
      footer: {
        WERZlogoColor: "#000000",
        text: "uppercase font-mono text-[11px] font-bold",
      },
      news: {
        container: "flex flex-col gap-4",
        header: "font-sans font-medium text-[18px] mb-[10px] text-center",
        loadingState:
          "font-mono mb-[32px] font-medium text-[14px] uppercase h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#000000] rounded-[6px]",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] border border-black rounded-[8px] flex justify-between",
          created: "text-[11px] text-[#828694] font-mono",
          media: "border border-black overflow-hidden rounded-[8px] m-2",
          name: "text-[14px] font-mono leading-[14px] uppercase font-medium one-line-truncate",
          triangleIconColor: "#000000",
        },
        seeAllNews: "underline text-[11px] font-mono text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "font-mono mb-[32px] font-medium text-[14px] uppercase h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#000000] rounded-[6px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        header: "font-sans font-medium text-[18px] mb-[10px] text-center",
        link: {
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#000000] object-cover",
          container:
            "h-[56px] cursor-pointer p-2 sm:w-[500px] w-[95vw] border border-black rounded-[8px] flex justify-between",
          name: "text-[14px] font-mono leading-[14px] font-medium",
          triangleIconColor: "#000000",
        },
      },
      radioTracks: {
        container: "flex flex-col gap-4",
        header: "font-sans font-medium text-[18px] mb-[10px] text-center",
        loadingState:
          "font-mono mb-[32px] font-medium text-[14px] uppercase h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#000000] rounded-[6px]",
        radioTrack: {
          container:
            "h-[64px] border cursor-pointer sm:w-[500px] w-[95vw] border-black rounded-[8px] flex",
          coverUrl: "border border-black overflow-hidden rounded-[8px] m-2",
          duration: "text-[11px] text-[#828694] font-mono",
          liveType: "text-[11px] text-[#FF1C5E] font-mono",
          liveTypeCircle: "w-2 h-2 bg-[#FF1C5E] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#FEFEF9",
          playIconBorderColor: "#000000",
          start: "text-[11px] text-[#39AF4F] font-mono",
          title:
            "text-[14px] font-mono leading-[14px] w-fit uppercase font-medium one-line-truncate",
        },
        seeAllTracks: "underline text-[11px] font-mono text-center mt-4 cursor-pointer mb-[32px]",
      },
      upcomingEvents: {
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] border border-black rounded-[8px] flex justify-between",
          duration: "uppercase text-[11px] text-[#828694] font-mono",
          media: "border border-black overflow-hidden rounded-[8px] m-2",
          name: "text-[14px] font-mono leading-[13px] uppercase font-medium one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
        },
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        emptyState: {
          button: "",
          container:
            "border sm:w-[500px] w-[95vw] border-black rounded-[8px] overflow-hidden flex flex-col justify-center items-center p-[34px] mb-[32px]",
          text: "font-mono text-[11px] text-[#828694]",
          title: "font-sans uppercase text-[14px] mb-1",
        },
        event: {
          button: "",
          container: "border border-black rounded-[8px] overflow-hidden sm:w-[500px] w-[95vw]",
          duration: "uppercase text-[11px] font-mono",
          location: "text-[11px] font-mono",
          name: "text-[18px] font-sans mb-1",
          product: {
            button: "",
            container: "h-[68px] border-t border-t-[#000000] p-4 flex justify-between",
            link: "text-[#828694] text-[11px] font-mono",
            name: "uppercase text-[14px] font-mono font-medium one-line-truncate sm:w-[390px] w-[65vw]",
            price: "uppercase text-[#828694] text-[11px] font-mono",
            status: "font-mono text-[14px] uppercase font-medium",
          },
          startDate:
            "w-[64px] h-[64px] rounded-[6px] bg-[#252934] font-sans text-[#FEFEF9] flex flex-col justify-center items-center gap-1",
        },
        header: "font-sans font-medium text-[18px] mb-[10px] text-center",
        loadingState:
          "font-mono mb-[32px] font-medium text-[14px] uppercase h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#000000] rounded-[6px]",
        seeAllEvents: "underline text-[11px] font-mono text-center mt-4 cursor-pointer mb-[32px]",
      },
    },
  },
}

export default wbase
